import * as React from "react";
import { SelectionModalDialog } from "main/javascripts/components/molecules/Modal/SelectionModalDialog";

export interface IProps {
  displayed: boolean;
  selectionType: string;
  closeHandler: any;
  initializedLIFF: boolean;
  initializedFacebookMessenger: boolean;
  hasCostMessage?: boolean;
  t?: any;
}

export class SocialWebViewSelectionModalDialog extends React.Component<IProps> {
  private closeHandler: () => void = async () => {
    const { initializedLIFF, initializedFacebookMessenger, closeHandler } =
      this.props;
    try {
      if (initializedLIFF) {
        liff.closeWindow();
      } else if (initializedFacebookMessenger) {
        (window as any).MessengerExtensions.requestCloseBrowser();
      }
    } catch (e) {
      //
    }
    if (closeHandler) {
      closeHandler();
    }
  };
  public render(): JSX.Element {
    const { displayed, hasCostMessage, selectionType } = this.props;
    return (
      <SelectionModalDialog
        displayed={displayed}
        selectionType={selectionType}
        closeHandler={this.closeHandler}
        hasCostMessage={hasCostMessage}
      />
    );
  }
}
